import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';
import { ContractPaymentType, ContractStatus } from '../enums';

export type StrategistEnrollmentDTO = {
  _id: string;
  studentId: string;
  studentName: string;
  courseTitle: string;
  courseColor?: string;
  status: number;
  startDate?: string;
  estimatedEndDate?: string;
  sessionsTotal: number;
  sessionsDone: number;
};

export type StrategistContractDTO = {
  _id: string;
  studentId: string;
  studentName: string;
  contractNumber?: string;
  contractDate?: string;
  amount: number;
  currency: string;
  paymentType?: ContractPaymentType;
  installmentsCount?: number;
  paidAmount?: number;
  remainingAmount?: number;
  status?: ContractStatus;
  source: 'agora' | 'hubspot';
  hubspotStage?: string;
  hubspotDealName?: string;
};

export type StrategistCurrencyTotalDTO = {
  currency: string;
  amount: number;
  paid: number;
  remaining: number;
};

export type StrategistHandoverDTO = {
  mentor: { _id: string; fullName: string; email?: string; status?: string };
  assignedStudents: number;
  taughtStudents: number;
  enrollmentsToReallocate: number;
  coursesToReallocate: { courseTitle: string; count: number }[];
  enrollments: StrategistEnrollmentDTO[];
  horizon: { earliestStart?: string; latestEnd?: string; monthsRemaining?: number };
  contracts: {
    count: number;
    full: number;
    installments: number;
    fullyPaid: number;
    unknownPaymentType: number;
    fromHubspot: number;
    totals: StrategistCurrencyTotalDTO[];
    rows: StrategistContractDTO[];
  };
};

export type StrategistsHandoverResponseDTO = {
  generatedAt: string;
  strategists: StrategistHandoverDTO[];
};

export const getStrategistsHandover: ApiDescription = {
  endpoint: '/admin/strategists/handover',
  method: RequestsMethod.Get,
};

export type GetStrategistsHandover = ApiData<unknown, StrategistsHandoverResponseDTO>;
